import React from 'react';
import '../template-file-css/document-file-template.css';


export const SSS_ProgressSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='SSS_ProgressSummary' className='file-pdf-document'>
            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Recipient Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>DOB:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtRecipientName' name='txtRecipientName' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDob' name='txtLastName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Client ID:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtClientId' name='txtClientId' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>
                        <center>Progress Summary</center>
                    </b>
                    <span className='eleHeader'>Date of Summary:</span>
                    <input type='date' id='txtDateOfSummary' name='txtDateOfSummary' className='add-only w-250' />

                    <span className='eleHeader'>Frequency of Progress Summaries:</span>

                    <input type='checkbox' id='cbFrequency_1' name='cbFrequency_1' className='add-only' value='Frequency_1' /> Completed at least every 90 days.
                    <br />
                    <input type='checkbox' id='cbFrequency_2' name='cbFrequency_2' className='add-only' value='Frequency_2' /> Last Summary Date ( Date: <input type='date' id='txtLastSummaryDate' name='txtLastSummaryDate' className='add-only w-250 custom-add-only' /> )
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>Date Range of Summary:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Start Date:</span></td>
                        <td className='w-375'><span className='eleHeader'>End Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='date' id='txtStartDate' name='txtStartDate' className='add-only' /></td>
                        <td className='w-375'><input type='date' id='txtEndDate' name='txtEndDate' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Participants:</b>
                    <span className='eleHeader'>List of Participants:</span>
                    <textarea id='txtParticipants' name='txtParticipants' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>Contact Location:</b>
                    <span className='eleHeader'>Location of Contact:</span>

                    <input type='text' id='txtContactLocation' name='txtContactLocation' className='add-only' />
                </p>
                <p className='w-750'>
                    <b>Activities:</b>
                    <span className='eleHeader'>Describe activities that occurred:</span>
                    <textarea id='txtActivities' name='txtActivities' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>Treatment Goals/Objectives:</b>

                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Goal 1</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Objective 1</span> </td></tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtGoal_1' name='txtGoal_1' className='add-only' /> </td>
                        <td className='w-375'>  <input type='text' id='txtObjective_1' name='txtObjective 1' className='add-only' /> </td></tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Goal 2</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Objective 2</span> </td></tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtGoal_2' name='txtGoal_2' className='add-only' /> </td>
                        <td className='w-375'>  <input type='text' id='txtObjective_2' name='txtObjective_2' className='add-only' /> </td></tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Goal 3</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Objective 3</span> </td></tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtGoal_3' name='txtGoal_3' className='add-only' /> </td>
                        <td className='w-375'>  <input type='text' id='txtObjective_3' name='txtObjective_3' className='add-only' /> </td></tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Goal 4</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Objective 4</span> </td></tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtGoal_4' name='txtGoal_4' className='add-only' /> </td>
                        <td className='w-375'>  <input type='text' id='txtObjective_4' name='txtObjective_4' className='add-only' /> </td></tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Goal 5</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Objective 5</span> </td></tr>
                    <tr>
                        <td className='w-375'>  <input type='text' id='txtGoal_5' name='txtGoal_5' className='add-only' /> </td>
                        <td className='w-375'>  <input type='text' id='txtObjective_5' name='txtObjective_5' className='add-only' /> </td></tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'> <b>Progress:</b></span>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalNeeds_1' name='cbAdditionalNeeds_1' className='add-only' value='AdditionalNeeds_1' /> Progressing toward personal outcomes.
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalNeeds_2' name='cbAdditionalNeeds_2' className='add-only' value='AdditionalNeeds_2' /> Lack of progression toward personal outcomes.
                        </td>
                    </tr>
                </p>
                <p className='w-750'>
                    <td className='w-750'><span className='eleHeader'><b>Explanation:</b></span></td>
                    <textarea id='txtExplanation_1' name='txtExpanation_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>Deviation from Treatment Plan (if applicable):</b></p>
                <tr>
                    <td className='w-375'>
                        <input type='radio' id='rbYes' name='rbAns' className='add-only' value='Yes' /> Yes &nbsp;
                        <input type='radio' id='rbNo' name='rbAns' className='add-only' value='No' /> No &nbsp;
                    </td>
                </tr>

                <p className='w-750'>
                    <td className='w-750'><span className='eleHeader'><b>Explanation:</b></span></td>
                    <textarea id='txtExplanation_2' name='txtExpanation_2' className='add-only'></textarea>
                    <b>Changes in Recipient's Condition:</b></p>
                <td className='w-750'>
                    <span className='eleHeader'>Indicate any changes in: </span>
                </td>
                <input type='checkbox' id='cbIndicate any changes in:_1' name='cbIndicate any changes in:_1' className='add-only' value='Indicate any changes in:_1' /> Medical Condition &nbsp;
                <input type='checkbox' id='cbIndicate any changes in:_2' name='cbIndicate any changes in:_2' className='add-only' value='Indicate any changes in:_2' /> Behavior &nbsp;
                <input type='checkbox' id='cbIndicate any changes in:_3' name='cbIndicate any changes in:_3' className='add-only' value='Indicate any changes in:_3' /> Home Situation &nbsp;

                <tr>
                    <p className='w-750'>
                        <span className='eleHeader'><b>Details:</b></span>
                        <textarea id='txtDetails' name='txtDetails' className='add-only'></textarea></p>
                </tr>

                <tr>
                    <td className='w-750'><span className='eleHeader'>Signature:</span></td>
                </tr>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of person completing the summary:
                        </td>
                        <td className='small w-375'>If initials used (Identify with correlating signatures: )</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Completer's Information</span></td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Functional Title:  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Educational Degree/Professional License:</td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Service Provider's Signature:</td>
                    </tr>
                </table>


            </div>
        </form>

    )
}